import React from "react";
import { ArrowLeft, AvatarPlaceholder, Logo, StoreIcon, UserCircle} from "assets/images";
import { Avatar } from "primereact/avatar";
import { Menubar } from "primereact/menubar";
import { Link } from "react-router-dom";
import { _Object } from "utils/interfaces";

const EmployeeLayout = () => {
  const items = [
    { label: 'Home', icon: 'pi pi-home' },
    { label: 'Store Info', icon: 'pi pi-qrcode' },
    { label: 'Promocode', icon: 'pi pi-question-circle' },
    { label: 'Used Deals', icon: 'pi pi-user' },
    { label: 'Add / Delete', icon: 'pi pi-question-circle' },
    { label: 'Notification', icon: 'pi pi-user' },
  ];



  return (
    <>
      <header className='main-header p-festival-header bg-white border-bottom-1 border-primary-color flex justify-content-center align-items-center'>
        <div className='flex justify-content-between align-items-center h-full' style={{ width: "850px" }}>
          <div className='flex flex-wrap align-items-center h-full'>
            <div className='h-full flex align-items-center pr-4 border-right-1 border-primary-color'>
            <Link to='/'><img src={Logo} alt="Logo" className='flex w-14rem' /></Link>
            </div>
            <h4 className='m-0 pl-4'>Decathlons Sports Store, Indore - ID1126587</h4>
          </div>

          <Link to="/" className='flex align-items-center'>
            <p className='mr-2 my-0 avatar-name'><i className="pi pi-wallet"></i>&nbsp;&nbsp; $100</p>
            <Avatar image={AvatarPlaceholder} shape="circle"/>
          </Link>
        </div>
      </header>

      <div className="employee-section">
        <div className="container mx-auto" style={{ width: "850px" }}>
          <div className="grid justify-content-center">
            <div className="col-8">
              <div className="customer-list">
                <ul className="list-unstyled pl-0">
                  <li className="flex justify-content-between align-items-center">
                    <Link to='#' className="flex align-items-center">
                      <img src={StoreIcon} alt="Logo" height={35} width={35} className='' />
                      &nbsp; Store
                    </Link>
                    <Link to='#'>
                      <img src={ArrowLeft} alt="Logo" className='' />
                    </Link>
                  </li>

                  <li className="flex justify-content-between align-items-center">
                    <Link to='#' className="flex align-items-center">
                      <img src={UserCircle} alt="Logo" height={35} width={35} className='' />
                      &nbsp; Customer
                    </Link>
                    <Link to='#'>
                      <img src={ArrowLeft} alt="Logo" className='' />
                    </Link>
                  </li>

                  <li className="flex justify-content-between align-items-center">
                    <Link to='#' className="flex align-items-center">
                      <img src={StoreIcon} alt="Logo" height={35} width={35} className='' />
                      &nbsp; Earnings
                    </Link>
                    <Link to='#'>
                      <img src={ArrowLeft} alt="Logo" className='' />
                    </Link>
                  </li>
                
                </ul>
              </div>
            </div>

          </div>

        </div>
      </div>

      <footer className='p-festival-footer bg-white mt-auto flex justify-content-center'>
        <Menubar model={items}
          className='bg-white border-0 border-noround'/>
      </footer>

  
    </>
  );
};

export default EmployeeLayout;
